// Estados de un reporte. El backend los guarda en inglés (BugReport::STATUSES) y la traducción
// vive acá, que es donde se leen.
export const STATUS_LABELS = {
    pending: "Sin revisar",
    in_review: "En revisión",
    resolved: "Resuelto",
};

export const STATUS_COLORS = {
    pending: "warning",
    in_review: "info",
    resolved: "success",
};

export const STATUS_OPTIONS = [
    { value: "open", label: "Sin resolver" },
    { value: "pending", label: "Sin revisar" },
    { value: "in_review", label: "En revisión" },
    { value: "resolved", label: "Resuelto" },
    { value: "all", label: "Todos" },
];

// Etiquetas del contexto que arma la app móvil (src/api/bug-report.ts), en el orden en que
// conviene leerlas. Una clave que no esté acá igual se muestra, con su nombre crudo: la app se
// actualiza por OTA y puede empezar a mandar campos que el front todavía no conoce.
export const CONTEXT_LABELS = {
    usuario: "Usuario",
    usuario_id: "ID de usuario",
    empresa: "Empresa",
    empresa_id: "ID de empresa",
    perfiles: "Perfiles",
    pantalla: "Pantalla",
    version: "Versión de la app",
    origen_version: "Origen de la versión",
    publicada: "Versión publicada el",
    canal: "Canal",
    plataforma: "Dispositivo",
    conexion: "Conexión",
    sin_enviar: "Operaciones sin enviar",
    fecha: "Fecha del reporte",
};

export const contextLabel = (key) => (
    CONTEXT_LABELS[key] || String(key).replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase())
);

// Primero los campos conocidos en el orden de CONTEXT_LABELS, después los que no conocemos.
export const orderedContextEntries = (context = {}) => {
    const keys = Object.keys(context || {});
    const known = Object.keys(CONTEXT_LABELS).filter((key) => keys.includes(key));
    const rest = keys.filter((key) => !CONTEXT_LABELS[key]);

    return [...known, ...rest]
        .map((key) => [key, context[key]])
        .filter(([, value]) => value !== null && value !== undefined && String(value) !== "");
};
